import React from 'react'
import { getHexColor, TwoColorIconProps } from '../utils'

export const GuildAgeIcon: React.FC<TwoColorIconProps> = ({
  size = 18,
  className,
  color1 = 'white',
  color2 = '#C48669',
}) => {
  const c1 = getHexColor(color1)
  const c2 = getHexColor(color2)

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.625 2.25C14.759 2.25 14.889 2.26756 15.0128 2.30053C14.7806 2.41144 14.5598 2.56377 14.3606 2.76301L13.3736 3.75L3.375 3.75V9C3.375 11.5781 5.42672 14.6189 9 15.7181C12.3775 14.6792 14.3956 11.9054 14.6066 9.42748L16.125 7.90909V9C16.125 12.3733 13.4736 16.0162 9.2038 17.2218C9.07054 17.2594 8.92946 17.2594 8.7962 17.2218C4.52641 16.0162 1.875 12.3733 1.875 9V3.74796C1.875 2.91688 2.54924 2.25 3.375 2.25H14.625Z"
        fill={c1}
      />
      <path
        d="M16.0886 3.75C15.9517 3.75 15.8308 3.77686 15.7257 3.83057C15.6627 3.86279 15.6054 3.90469 15.5539 3.95625L9.19763 10.3125L6.51638 7.63125C6.37888 7.49375 6.20388 7.425 5.99138 7.425C5.77888 7.425 5.60388 7.49375 5.46638 7.63125C5.32888 7.76875 5.25688 7.94675 5.25038 8.16525C5.24438 8.38425 5.31013 8.5625 5.44763 8.7L8.67263 11.925C8.74763 12 8.82888 12.053 8.91638 12.084C9.00388 12.1155 9.09763 12.1313 9.19763 12.1313C9.29763 12.1313 9.39138 12.1155 9.47888 12.084C9.56638 12.053 9.64763 12 9.72263 11.925L16.6226 5.025C16.7601 4.8875 16.8289 4.70925 16.8289 4.49025C16.8289 4.27175 16.7601 4.09375 16.6226 3.95625C16.4851 3.81875 16.3071 3.75 16.0886 3.75Z"
        fill={c2}
      />
    </svg>
  )
}
